/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  CreateCryptoLink200Response,
  CreateCryptoLink422Response,
  CreateCryptoLinkRequest,
  CreateStoredCryptoLinkRequest,
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetCommonState400Response,
  ShowCryptoLink200Response,
  ShowCryptoLink400Response,
} from '../models/index'
import {
  CreateCryptoLink200ResponseFromJSON,
  CreateCryptoLink200ResponseToJSON,
  CreateCryptoLink422ResponseFromJSON,
  CreateCryptoLink422ResponseToJSON,
  CreateCryptoLinkRequestFromJSON,
  CreateCryptoLinkRequestToJSON,
  CreateStoredCryptoLinkRequestFromJSON,
  CreateStoredCryptoLinkRequestToJSON,
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  ShowCryptoLink200ResponseFromJSON,
  ShowCryptoLink200ResponseToJSON,
  ShowCryptoLink400ResponseFromJSON,
  ShowCryptoLink400ResponseToJSON,
} from '../models/index'

export interface CreateCryptoLinkOperationRequest {
  createCryptoLinkRequest: CreateCryptoLinkRequest
}

export interface CreateStoredCryptoLinkOperationRequest {
  createStoredCryptoLinkRequest: CreateStoredCryptoLinkRequest
}

export interface ShowCryptoLinkRequest {
  token: string
}

export interface ShowStoredCryptoLinkRequest {
  token: string
}

/**
 * CryptoLinksApi - interface
 *
 * @export
 * @interface CryptoLinksApiInterface
 */
export interface CryptoLinksApiInterface {
  /**
   * Формирует шифрованную ссылку (пробный функционал): произвольный payload вместе со сроком жизни шифруется (AES-256-CBC + HMAC, ключ APP_KEY) и укладывается в URL-safe токен пути. Чтение payload — публичным GET /crypto-links/{token}.
   * @summary Создать шифрованную ссылку
   * @param {CreateCryptoLinkRequest} createCryptoLinkRequest Payload для шифрования и срок жизни ссылки
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CryptoLinksApiInterface
   */
  createCryptoLinkRaw(
    requestParameters: CreateCryptoLinkOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreateCryptoLink200Response>>

  /**
   * Формирует шифрованную ссылку (пробный функционал): произвольный payload вместе со сроком жизни шифруется (AES-256-CBC + HMAC, ключ APP_KEY) и укладывается в URL-safe токен пути. Чтение payload — публичным GET /crypto-links/{token}.
   * Создать шифрованную ссылку
   */
  createCryptoLink(
    requestParameters: CreateCryptoLinkOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreateCryptoLink200Response>

  /**
   * Формирует шифрованную ссылку с хранением payload в БД (пробный функционал): payload сохраняется в таблице crypto_links, наружу отдаётся короткий токен ULID.HMAC-подпись (около 35 символов). Досрочный отзыв ссылки возможен удалением записи. Чтение payload — публичным GET /crypto-links/stored/{token}.
   * @summary Создать шифрованную ссылку (payload в БД)
   * @param {CreateStoredCryptoLinkRequest} createStoredCryptoLinkRequest Payload для сохранения и срок жизни ссылки
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CryptoLinksApiInterface
   */
  createStoredCryptoLinkRaw(
    requestParameters: CreateStoredCryptoLinkOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreateCryptoLink200Response>>

  /**
   * Формирует шифрованную ссылку с хранением payload в БД (пробный функционал): payload сохраняется в таблице crypto_links, наружу отдаётся короткий токен ULID.HMAC-подпись (около 35 символов). Досрочный отзыв ссылки возможен удалением записи. Чтение payload — публичным GET /crypto-links/stored/{token}.
   * Создать шифрованную ссылку (payload в БД)
   */
  createStoredCryptoLink(
    requestParameters: CreateStoredCryptoLinkOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreateCryptoLink200Response>

  /**
   * Публичный переход по шифрованной ссылке (без авторизации): расшифровывает токен и возвращает исходный payload, если ссылка валидна и срок её действия не истёк.
   * @summary Перейти по шифрованной ссылке
   * @param {string} token Зашифрованный токен ссылки (URL-safe base64)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CryptoLinksApiInterface
   */
  showCryptoLinkRaw(
    requestParameters: ShowCryptoLinkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ShowCryptoLink200Response>>

  /**
   * Публичный переход по шифрованной ссылке (без авторизации): расшифровывает токен и возвращает исходный payload, если ссылка валидна и срок её действия не истёк.
   * Перейти по шифрованной ссылке
   */
  showCryptoLink(
    requestParameters: ShowCryptoLinkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ShowCryptoLink200Response>

  /**
   * Публичный переход по шифрованной ссылке с коротким токеном (без авторизации): проверяет HMAC-подпись, находит запись в БД и возвращает сохранённый payload, если ссылка валидна и срок её действия не истёк.
   * @summary Перейти по ссылке с коротким токеном
   * @param {string} token Короткий токен: ULID (26 символов) и HMAC-подпись (8 hex-символов), разделённые точкой
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CryptoLinksApiInterface
   */
  showStoredCryptoLinkRaw(
    requestParameters: ShowStoredCryptoLinkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ShowCryptoLink200Response>>

  /**
   * Публичный переход по шифрованной ссылке с коротким токеном (без авторизации): проверяет HMAC-подпись, находит запись в БД и возвращает сохранённый payload, если ссылка валидна и срок её действия не истёк.
   * Перейти по ссылке с коротким токеном
   */
  showStoredCryptoLink(
    requestParameters: ShowStoredCryptoLinkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ShowCryptoLink200Response>
}

/**
 *
 */
export class CryptoLinksApi
  extends runtime.BaseAPI
  implements CryptoLinksApiInterface
{
  /**
   * Формирует шифрованную ссылку (пробный функционал): произвольный payload вместе со сроком жизни шифруется (AES-256-CBC + HMAC, ключ APP_KEY) и укладывается в URL-safe токен пути. Чтение payload — публичным GET /crypto-links/{token}.
   * Создать шифрованную ссылку
   */
  async createCryptoLinkRaw(
    requestParameters: CreateCryptoLinkOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreateCryptoLink200Response>> {
    if (requestParameters['createCryptoLinkRequest'] == null) {
      throw new runtime.RequiredError(
        'createCryptoLinkRequest',
        'Required parameter "createCryptoLinkRequest" was null or undefined when calling createCryptoLink().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/crypto-links`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CreateCryptoLinkRequestToJSON(
          requestParameters['createCryptoLinkRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateCryptoLink200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Формирует шифрованную ссылку (пробный функционал): произвольный payload вместе со сроком жизни шифруется (AES-256-CBC + HMAC, ключ APP_KEY) и укладывается в URL-safe токен пути. Чтение payload — публичным GET /crypto-links/{token}.
   * Создать шифрованную ссылку
   */
  async createCryptoLink(
    requestParameters: CreateCryptoLinkOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreateCryptoLink200Response> {
    const response = await this.createCryptoLinkRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Формирует шифрованную ссылку с хранением payload в БД (пробный функционал): payload сохраняется в таблице crypto_links, наружу отдаётся короткий токен ULID.HMAC-подпись (около 35 символов). Досрочный отзыв ссылки возможен удалением записи. Чтение payload — публичным GET /crypto-links/stored/{token}.
   * Создать шифрованную ссылку (payload в БД)
   */
  async createStoredCryptoLinkRaw(
    requestParameters: CreateStoredCryptoLinkOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreateCryptoLink200Response>> {
    if (requestParameters['createStoredCryptoLinkRequest'] == null) {
      throw new runtime.RequiredError(
        'createStoredCryptoLinkRequest',
        'Required parameter "createStoredCryptoLinkRequest" was null or undefined when calling createStoredCryptoLink().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/crypto-links/stored`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CreateStoredCryptoLinkRequestToJSON(
          requestParameters['createStoredCryptoLinkRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateCryptoLink200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Формирует шифрованную ссылку с хранением payload в БД (пробный функционал): payload сохраняется в таблице crypto_links, наружу отдаётся короткий токен ULID.HMAC-подпись (около 35 символов). Досрочный отзыв ссылки возможен удалением записи. Чтение payload — публичным GET /crypto-links/stored/{token}.
   * Создать шифрованную ссылку (payload в БД)
   */
  async createStoredCryptoLink(
    requestParameters: CreateStoredCryptoLinkOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreateCryptoLink200Response> {
    const response = await this.createStoredCryptoLinkRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Публичный переход по шифрованной ссылке (без авторизации): расшифровывает токен и возвращает исходный payload, если ссылка валидна и срок её действия не истёк.
   * Перейти по шифрованной ссылке
   */
  async showCryptoLinkRaw(
    requestParameters: ShowCryptoLinkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ShowCryptoLink200Response>> {
    if (requestParameters['token'] == null) {
      throw new runtime.RequiredError(
        'token',
        'Required parameter "token" was null or undefined when calling showCryptoLink().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/crypto-links/{token}`.replace(
          `{${'token'}}`,
          encodeURIComponent(String(requestParameters['token']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShowCryptoLink200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Публичный переход по шифрованной ссылке (без авторизации): расшифровывает токен и возвращает исходный payload, если ссылка валидна и срок её действия не истёк.
   * Перейти по шифрованной ссылке
   */
  async showCryptoLink(
    requestParameters: ShowCryptoLinkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ShowCryptoLink200Response> {
    const response = await this.showCryptoLinkRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Публичный переход по шифрованной ссылке с коротким токеном (без авторизации): проверяет HMAC-подпись, находит запись в БД и возвращает сохранённый payload, если ссылка валидна и срок её действия не истёк.
   * Перейти по ссылке с коротким токеном
   */
  async showStoredCryptoLinkRaw(
    requestParameters: ShowStoredCryptoLinkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ShowCryptoLink200Response>> {
    if (requestParameters['token'] == null) {
      throw new runtime.RequiredError(
        'token',
        'Required parameter "token" was null or undefined when calling showStoredCryptoLink().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/crypto-links/stored/{token}`.replace(
          `{${'token'}}`,
          encodeURIComponent(String(requestParameters['token']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShowCryptoLink200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Публичный переход по шифрованной ссылке с коротким токеном (без авторизации): проверяет HMAC-подпись, находит запись в БД и возвращает сохранённый payload, если ссылка валидна и срок её действия не истёк.
   * Перейти по ссылке с коротким токеном
   */
  async showStoredCryptoLink(
    requestParameters: ShowStoredCryptoLinkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ShowCryptoLink200Response> {
    const response = await this.showStoredCryptoLinkRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}
